export const UI_HIDE_COOKIE_BANNER = 'ui/HIDE_COOKIE_BANNER'
